import React from 'react';
import { FormattedNumber } from 'react-intl';
import { Table, Dropdown, Popup } from 'semantic-ui-react';
import { utcMoment, dateTimeFormatted } from '../../utilities/dateUtils';
import { PRODUCT_FAMILY_SA } from '../../constants/productFamily';
import './ListRow.css';

const formatDate = date => (date ? dateTimeFormatted(utcMoment(date)) : '');

const IneligiblePurchasesListRow = (actionHandler, selectedProduct) => ineligiblePurchase => {
  const rowMenuOptions = [
    { key: 1, text: 'Status History', value: 'Audit' },
  ];

  const {
    externalId,
    vin,
    make,
    model,
    modelYear,
    odometer,
    salePrice,
    auctionCode,
    auctionName,
    saleNumber,
    saleLane,
    saleRun,
    purchaseDate,
    ineligibilityCode,
    ineligibilityReason,
    ineligibilityNotice,
    productCategory,
    sellerNo,
    buyerNo,
  } = ineligiblePurchase;

  // Under the "All Products" filter the list mixes products, so the dealer side
  // has to come from the row itself; `selectedProduct` is only a fallback for
  // rows that arrive without a category. Seller Guarantee is seller-side, every
  // other product is buyer-side.
  const rowProduct = productCategory || selectedProduct;
  const dealerNumber = rowProduct === PRODUCT_FAMILY_SA ? sellerNo : buyerNo;

  const vehicle = [modelYear, make, model].filter(Boolean).join(' ');

  const currencyProps = price => ({
    currency: 'USD',
    style: 'currency',
    minimumFractionDigits: 0,
    value: price,
  });

  const auctionInfo = [
    auctionName || auctionCode,
    saleNumber,
    saleLane,
    saleRun,
  ]
    .filter(part => part !== null && part !== undefined && part !== '')
    .join(' / ');

  const failureReason = (
    <span className='ineligible-failure-reason'>
      {ineligibilityReason || ineligibilityCode}
    </span>
  );

  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, ineligiblePurchase);
  };

  return (
    <Table.Row key={externalId} data-testid='purchase-row'>
      <Table.Cell>{vin}</Table.Cell>
      <Table.Cell>{formatDate(purchaseDate)}</Table.Cell>
      <Table.Cell>{dealerNumber}</Table.Cell>
      <Table.Cell>{auctionInfo}</Table.Cell>
      <Table.Cell>{vehicle}</Table.Cell>
      <Table.Cell>
        {odometer != null && <FormattedNumber value={odometer} />}
      </Table.Cell>
      <Table.Cell>
        {salePrice != null
          && React.createElement(FormattedNumber, currencyProps(salePrice))}
      </Table.Cell>
      <Table.Cell data-testid='failure-reason-cell'>
        {ineligibilityNotice ? (
          <Popup
            trigger={failureReason}
            content={ineligibilityNotice}
            position='top right'
          />
        ) : (
          failureReason
        )}
      </Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          value={null}
          disabled
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default IneligiblePurchasesListRow;
